import React, { useState } from 'react';
import { Form, Button, Alert, Container, Card, Row, Col } from 'react-bootstrap';
import DataService from '../../services/data.service';

const FileUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [successful, setSuccessful] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setMessage('');
      setSuccessful(false);
      setError('');
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);
    setSuccessful(false);

    if (!selectedFile) {
      setError('Por favor seleccione un archivo');
      setLoading(false);
      return;
    }

    const fileType = selectedFile.name.split('.').pop().toLowerCase();
    if (!['csv', 'xls', 'xlsx'].includes(fileType)) {
      setError('Solo se permiten archivos CSV o Excel');
      setLoading(false);
      return;
    }

    try {
      const response = await DataService.uploadFile(selectedFile);
      setMessage(response.data.message);
      setSuccessful(true);
      setLoading(false);
      
      // Limpiar el input de archivo
      document.getElementById('fileInput').value = '';
      setSelectedFile(null);
    } catch (error) {
      console.error('Error durante la carga del archivo:', error);
      
      const resMessage = error.response && error.response.data && error.response.data.detail
        ? error.response.data.detail
        : 'Error al procesar el archivo. Por favor intente de nuevo.';
      
      setError(resMessage);
      setSuccessful(false);
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card>
            <Card.Header as="h5">Subir Datos del Agua Cruda</Card.Header>
            <Card.Body>
              <Form onSubmit={handleUpload}>
                <Form.Group className="mb-3">
                  <Form.Label>Seleccionar Archivo (XLS, XLSX)</Form.Label>
                  <Form.Control
                    id="fileInput"
                    type="file"
                    onChange={handleFileChange}
                    accept=".csv, .xls, .xlsx"
                    required
                  />
                  <Form.Text className="text-muted">
                    El archivo debe contener columnas para: Fecha, Hora, Caudal, PH Cruda, Color y Turbiedad
                  </Form.Text>
                </Form.Group>

                <Button variant="primary" type="submit" disabled={loading || !selectedFile}>
                  {loading ? 'Subiendo...' : 'Subir Archivo'}
                </Button>

                {message && (
                  <Alert variant="success" className="mt-3">
                    {message}
                  </Alert>
                )}

                {error && (
                  <Alert variant="danger" className="mt-3">
                    {error}
                  </Alert>
                )}
              </Form>

              <Card className="mt-4">
                <Card.Header>Formato del Archivo</Card.Header>
                <Card.Body>
                  <p>El archivo debe incluir las siguientes columnas:</p>
                  <ul>
                    <li><strong>Fecha</strong>: En formato DD/MM/YYYY (27/03/2025)</li>
                    <li><strong>Hora</strong>: Formato HH:MM:SS o número de hora (8:00 o simplemente 8)</li>
                    <li><strong>Caudal</strong>: Valor numérico en m³/h</li>
                    <li><strong>PH Cruda</strong>: Valor numérico</li>
                    <li><strong>Color</strong>: Valor numérico en UCV</li>
                    <li><strong>Turbiedad</strong>: Valor numérico en NTU</li>
                  </ul>
                  <p>Algunos nombres alternativos aceptados para columnas:</p>
                  <ul>
                    <li><strong>Fecha</strong>: fecha, date, día, dia</li>
                    <li><strong>Hora</strong>: hora, time, hora del día</li>
                    <li><strong>Caudal</strong>: caudal, flow, caudal (m3/h)</li>
                    <li><strong>PH Cruda</strong>: ph cruda, ph, ph_cruda</li>
                    <li><strong>Color</strong>: color, color (ucv)</li>
                    <li><strong>Turbiedad</strong>: turbiedad, turb, turbidity</li>
                  </ul>
                </Card.Body>
              </Card>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FileUpload;